<template>
  <div class="animated fadeIn brief-datos">
    <b-row>
      <b-col cols="12">
        <b-form>
          <b-card header= "Información de la Acción">
            <!-- <b-form-group
              label="Nro. PI"
              label-for="presupuestoNumero"
              :labelCols="labelCols"
              v-if="presupuestoNumero != ''"
              horizontal>
              <b-form-input 
                id="presupuestoNumero"
                :value="presupuestoNumero"
                type="text"
                readonly>
              </b-form-input>
            </b-form-group> -->

            <b-form-group
              label="Nro. Brief"
              label-for="id"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="id"
                :value="id"
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Cliente"
              label-for="cliente"
              :label-cols="2"
              horizontal>
              <b-form-input 
                id="cliente"
                :value="cliente"
                readonly
                type="text"/>
            </b-form-group>

            <b-form-group
              label="Acción"
              label-for="accion"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="accion"
                :value="accion" 
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Tipo de Presupuesto"
              label-for="tipoPresupuesto"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="tipoPresupuesto"
                :value="tipoPresupuesto" 
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Canal"
              label-for="canal"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="canal"
                :value="canal" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Subcliente"
              label-for="subcliente"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="subcliente"
                :value="subcliente" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Nro. PI"
              label-for="presupuestosNumero"
              :labelCols="labelCols"
              description="Uno o más presupuestos internos asociados"
              horizontal>
              <b-form-input 
                id="presupuestosNumero"
                :value="presupuestosNumero"
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              v-if="isCerrado"
              label="Fecha de Cierre"
              label-for="fechaCierre"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaCierre"
                :value="fechaCierre | fechaHora"
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>
          </b-card>
          
          <app-presupuestos-internos 
            ref="presupuestosInternos"
            :presupuestosInternos="presupuestosInternos">
          </app-presupuestos-internos>

          <app-usuarios ref="usuarios"/>

          <b-card no-header>
            <b-tabs @input="setTabIndex" justified>
              <b-tab title="Especificaciones" active>
                <b-form>
                  <b-form-group
                    label="Objetivo/Contexto del Pedido"
                    label-for="descripcion"
                    :labelCols="labelCols"
                    description="Detalla el pedido que realizó el cliente indicando aspectos generales de la campaña, objetivos, etc. para dar contexto a los/as diseñadores/as sobre esta solicitud."
                    horizontal>
                    <b-form-textarea
                      id="descripcion"
                      :value="descripcion" 
                      rows="3"
                      readonly>
                    </b-form-textarea>
                  </b-form-group>

                  <!-- <b-form-group
                    label="Requerimientos"
                    label-for="requerimientos"
                    :labelCols="labelCols"
                    description="Indicar los requerimientos de la solicitud"
                    horizontal>
                    <b-form-textarea
                      id="requerimientos"
                      :value="requerimientos" 
                      rows="3"
                      max-rows="6"
                      readonly>
                    </b-form-textarea>
                  </b-form-group> -->
                  <app-tipos-disenios ref="tiposDisenios"/>

                  <b-form-group
                    v-if="!mecanicaPromocionalVisible"
                    label="Diseño de Visual"
                    label-for="requerimientosDisenio"
                    :labelCols="labelCols"
                    description="Indicar todos los detalles para armar el visual que luego se adaptará a las piezas o formatos necesarios."
                    horizontal>
                    <b-form-textarea
                      id="requerimientosDisenio"
                      :value="requerimientosDisenio" 
                      rows="10"
                      readonly>
                    </b-form-textarea>
                  </b-form-group>

                  <b-form-group
                    v-if="descripcionAdicionales != ''"
                    label="Adicionales"
                    label-for="descripcionAdicionales"
                    :labelCols="labelCols"
                    horizontal>
                    <b-form-textarea
                      id="descripcionAdicionales"
                      :value="descripcionAdicionales" 
                      rows="3"
                      readonly>
                    </b-form-textarea>
                  </b-form-group>
                </b-form>
              </b-tab>

              <b-tab title="Adjuntos">
                <app-imagenes/>
              </b-tab>

              <b-tab title="Marcas">
                <app-marcas ref="marcas"/>
              </b-tab>

              <b-tab title="Entrega">
                <b-form>
                  <!-- <b-form-group label="Forma de Entrega">
                    <b-form-radio v-model="selected" :aria-describedby="ariaDescribedby" name="some-radios" value="A">Option A</b-form-radio>
                    <b-form-radio v-model="selected" :aria-describedby="ariaDescribedby" name="some-radios" value="B">Option B</b-form-radio>
                  </b-form-group> -->
                  <div class="subtitulo">                
                    <label>Forma de Entrega</label>
                    <small class="text-muted">¿se va a imprimir? ¿se va a enviar editable? ¿solo será digital? Seleccionar todas las respuestas que correspondan.</small>
                  </div>

                  <b-list-group flush class="formas-entrega">
                    <b-list-group-item>
                      <p><i :class="{ 'fa': true,
                        'fa-check-square-o': formaEntregaEditable,
                        'fa-square-o': !formaEntregaEditable }"/> Voy a necesitar editable</p>
                    </b-list-group-item>

                    <b-list-group-item>
                      <p><i :class="{ 'fa': true,
                        'fa-check-square-o': formaEntregaDigital,
                        'fa-square-o': !formaEntregaDigital }"/> Las piezas serán solo digitales</p>
                    </b-list-group-item>

                    <b-list-group-item>
                      <p><i :class="{ 'fa': true,
                        'fa-check-square-o': formaEntregaImpresion,
                        'fa-square-o': !formaEntregaImpresion }"/> Las piezas se van a imprimir</p>
                    </b-list-group-item>

                    <b-list-group-item>
                      <p><i :class="{ 'fa': true,
                        'fa-check-square-o': formaEntregaAdaptacion,
                        'fa-square-o': !formaEntregaAdaptacion }"/> Voy a necesitar adaptaciones para PPT</p>
                    </b-list-group-item>

                    <b-list-group-item>
                      <p><i :class="{ 'fa': true,
                        'fa-check-square-o': formaEntregaIndefinida,
                        'fa-square-o': !formaEntregaIndefinida }"/> Todavía no está definido</p>
                    </b-list-group-item>

                    <b-list-group-item>
                      <p><i :class="{ 'fa': true,
                        'fa-check-square-o': formaEntregaOtros,
                        'fa-square-o': !formaEntregaOtros }"/> Otra: {{ formaEntregaOtrosDescripcion }}</p>
                    </b-list-group-item>
                  </b-list-group>

                  <br>
                  <br>

                  <div class="subtitulo">
                    <label class="titulo">Timing</label>
                    <small class="text-muted">Indicar las fechas estimadas de entrega</small>
                  </div>
                  
                  <b-form-group
                    label="Primera Muestra"
                    label-for="fechaEntregaMuestra"
                    description="Fecha de entrega de primera muestra"
                    :label-cols="labelCols">
                    <b-form-input 
                      id="fechaEntregaMuestra" 
                      :value="fechaEntregaMuestra | fechaHora" 
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="Originales"
                    label-for="fechaEntregaOriginales"
                    description="Fecha de entrega de originales"
                    :label-cols="labelCols">
                    <b-form-input 
                      id="fechaEntregaOriginales" 
                      :value="fechaEntregaOriginales | fechaHora" 
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="Implementación / Inicio"
                    label-for="fechaImplementacion"
                    description="Fecha de implementación o inicio de vigencia"
                    :label-cols="labelCols">
                    <b-form-input 
                      id="fechaImplementacion" 
                      :value="fechaImplementacion | fechaHora" 
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>
                </b-form>
              </b-tab>

              <b-tab title="Adicionales">
                <app-adicionales 
                  ref="adicionales"
                  :adicionales="adicionales"/>
              </b-tab>

              <b-tab title="Cambios">
                <app-cambios 
                  ref="cambios"
                  :cambios="cambios"/>
              </b-tab>

              <b-tab title="Muestras/Originales">
                <app-muestras 
                  ref="muestras"
                  :isOriginales="false"
                  :entregas="muestras"
                  :isCerrado="isCerrado"
                  @addEntrega="addMuestra"
                  @removeEntrega="removeMuestra"                  
                  @validarEntrega="validarInformacionEntrega"
                  @addEspecificaciones="addEspecificacionesMuestra"/>

                <hr class="separador-entregas">

                <app-originales 
                  ref="originales"
                  :isOriginales="true"
                  :entregas="originales"
                  :isCerrado="isCerrado"
                  @addEntrega="addOriginal"
                  @removeEntrega="removeOriginal"                  
                  @validarEntrega="validarTecnicaEntrega"
                  @addSolicitudCambios="addSolicitudCambios"
                  @deleteSolicitudCambios="deleteSolicitudCambios"
                  @solucionarSolicitudCambios="solucionarSolicitudCambios"/>
              </b-tab>

              <!-- <b-tab title="Autorizaciones">
                <app-validaciones ref="validaciones"/>
              </b-tab> -->
            </b-tabs>
          </b-card>

          <b-card header="Mecánica Promocional" v-if="mecanicaPromocionalVisible">
            <b-form>
              <b-form-group
                label="Titular"
                label-for="titular"
                :labelCols="labelCols"
                horizontal>
                <b-form-input 
                  id="titular"
                  :value="titular" 
                  type="text"
                  readonly>
                </b-form-input>
              </b-form-group>

              <b-form-group
                label="Mecánica"
                label-for="mecanica"
                :labelCols="labelCols"
                horizontal>
                <b-form-textarea
                  id="mecanica"
                  :value="mecanica" 
                  rows="3"
                  readonly>
                </b-form-textarea>
              </b-form-group>

              <b-form-group
                label="Premios"
                label-for="premios"
                :labelCols="labelCols"
                horizontal>
                <b-form-textarea
                  id="premios"
                  :value="premios" 
                  rows="3"
                  readonly>
                </b-form-textarea>
              </b-form-group>

              <b-form-group
                label="Pie Legal"
                label-for="pieLegal"
                :labelCols="labelCols"
                description="Incluir pie legal corto y largo de ser necesario"
                horizontal>
                <b-form-textarea
                  id="pieLegal"
                  :value="pieLegal" 
                  rows="3"
                  readonly>
                </b-form-textarea>
              </b-form-group>

              <b-form-group
                label="Adaptaciones"
                label-for="piezas"
                :labelCols="labelCols"
                description="Piezas a diseñar/adaptaciones. Incluir cantidades, medidas y modelos"
                horizontal>
                <b-form-textarea
                  id="piezas"
                  :value="piezas" 
                  rows="3"
                  readonly>
                </b-form-textarea>
              </b-form-group>

              <b-form-group
                label="Diseño de Visual"
                label-for="requerimientosDisenio"
                :labelCols="labelCols"
                description="Indicar todos los detalles para armar el visual que luego se adaptará a las piezas o formatos necesarios."
                horizontal>
                <b-form-textarea
                  id="requerimientosDisenio"
                  :value="requerimientosDisenio" 
                  rows="10"
                  readonly>
                </b-form-textarea>
              </b-form-group>
              
              <br>

              <label>A quien esta dirigida la acción?</label>
              <!-- <label class="titulo">A quien esta dirigida la acción?</label> -->

              <b-list-group flush class="accion-objetivos">
                <b-list-group-item>
                  <p><i :class="{ 'fa': true,
                    'fa-check-square-o': accionPuntoVenta,
                    'fa-square-o': !accionPuntoVenta }"/> Punto de Venta (Owners: dueños/encargados de PdV)</p>
                </b-list-group-item>

                <b-list-group-item>
                  <p><i :class="{ 'fa': true,
                    'fa-check-square-o': accionConsumidorFinal,
                    'fa-square-o': !accionConsumidorFinal }"/> Consumidores Finales</p>
                </b-list-group-item>

                <b-list-group-item>
                  <p><i :class="{ 'fa': true,
                    'fa-check-square-o': accionFuerzaVenta,
                    'fa-square-o': !accionFuerzaVenta }"/> Fuerza de Venta</p>
                </b-list-group-item>

                <b-list-group-item>
                  <p><i :class="{ 'fa': true,
                    'fa-check-square-o': accionOtros,
                    'fa-square-o': !accionOtros }"/> Otros: {{ accionOtrosDescripcion }}</p>
                </b-list-group-item>
              </b-list-group>
            </b-form>
          </b-card>
        </b-form>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <!-- <b-dropdown-item @click.stop="exportPDF">
            <i class="fa fa-file-pdf-o"></i>Emitir Certificado</b-dropdown-item> -->
          <b-dropdown-item 
              v-if="opcionEditarBrief"
              :disabled="isCerrado"
              @click.stop="editar">
            <i class="fa fa-edit"></i>Editar Brief de Diseño</b-dropdown-item>
          <b-dropdown-item 
              @click.stop="goList">
            <i class="fa fa-undo"></i>Volver al Listado</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <b-modal ref="addMuestraModal"
        title="Nueva Muestra"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-muestra
        :briefId="id"
        :isMuestra="true"
        @saved="savedMuestra"
        @close="closeMuestra">
      </app-muestra>  
    </b-modal>

    <b-modal ref="addOriginalModal"
        title="Nuevo Original"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-original
        :briefId="id"
        :isMuestra="false"
        @saved="savedOriginal"
        @close="closeOriginal">
      </app-original>  
    </b-modal>

    <b-modal ref="cambiosModal"
        title="Solicitud de Cambios"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-cambios-original-add
        :briefId="parseInt(id)"
        :briefEntregaId="briefOriginalId"
        @solicitudCambiosRegistrada="solicitudCambiosRegistrada"
        @cancelarSolicitudCambios="cancelarCambios">
      </app-cambios-original-add>
    </b-modal>

    <b-modal ref="validacionInformacionModal"
        title="Validación Comercial"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-validacion-informacion-add
        :especificacionesMuestra="briefMuestraEspecificaciones"
        @registrarValidacion="registrarValidacionInformacion"
        @cancelarValidacion="cancelarValidacionInformacion">
      </app-validacion-informacion-add>
    </b-modal>

    <b-modal ref="especificacionesMuestraModal"
        title="Especificaciones de la Muestra"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-especificaciones-add
        @registrarEspecificaciones="registrarEspecificacionesMuestra"
        @cancelarEspecificaciones="cancelarEspecificacionesMuestra">
      </app-especificaciones-add>
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
// import CambiosAdd from './CambiosAdd.vue'
import CambiosOriginalAdd from './CambiosOriginalAdd.vue';
import ValidacionInformacionAdd from './ValidacionInformacionAdd.vue';
import EspecificacionesAdd from './EspecificacionesAdd.vue'
import PresupuestosInternos from './PresupuestosInternosData.vue';
import Usuarios from './UsuariosData.vue';
import Marcas from './MarcasData.vue';
import Imagenes from './ImagenesData.vue';
import TiposDisenios from './TiposDiseniosData.vue';
import Adicionales from './Adicionales.vue';
import Cambios from './Cambios.vue';
// import Cambios from './CambiosData.vue';
import Muestras from './Entregas.vue';
import Originales from './Entregas.vue';
import Muestra from './EntregaAdd.vue';
import Original from './EntregaAdd.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'briefDatos/getField',
  mutationType: 'briefDatos/updateField',
});

export default {
  name: 'BriefData',
  components: {
    // appCambiosAdd: CambiosAdd,
    appCambiosOriginalAdd: CambiosOriginalAdd,
    appValidacionInformacionAdd: ValidacionInformacionAdd,
    appEspecificacionesAdd: EspecificacionesAdd,
    appPresupuestosInternos: PresupuestosInternos,
    appUsuarios: Usuarios,
    appMarcas: Marcas,
    appMuestras: Muestras,
    appOriginales: Originales,
    appMuestra: Muestra,
    appOriginal: Original,
    // appValidaciones: Validaciones,
    appImagenes: Imagenes,
    appTiposDisenios: TiposDisenios,
    appAdicionales: Adicionales,
    appCambios: Cambios,
    appMensaje: Mensaje,
    appConfirm: Confirm
  },
  mixins: [ 
    msjModal,
    confirmModal
  ],
  data () {
    return {
      briefOriginalId: 0,
      briefMuestraId: 0,
      briefMuestraEspecificaciones: '',

      tabIndex: 0,
      labelCols: 2,

      opcionEditarBrief: false
    }
  },
  computed: {
    ...mapFields([
      'id',
      // 'presupuestoNumero',
      'cliente',
      'accion',
      'tipoPresupuesto',
      'canal',
      'subcliente',
      'descripcion',
      'descripcionAdicionales',
      'accionPuntoVenta',
      'accionConsumidorFinal',
      'accionFuerzaVenta',
      'accionOtros',
      'accionOtrosDescripcion',
      'titular',
      'mecanica',
      'premios',
      'pieLegal',
      'piezas',
      'requerimientosDisenio',
      'formaEntregaEditable',
      'formaEntregaDigital',
      'formaEntregaImpresion',
      'formaEntregaAdaptacion',
      'formaEntregaIndefinida',
      'formaEntregaOtros',
      'formaEntregaOtrosDescripcion',
      'fechaEntregaMuestra',
      'fechaEntregaOriginales',
      'fechaImplementacion',
      'especificacionesProduccion',
      'tiposDisenios',

      'isCerrado',
      'fechaCierre',

      'adicionales',
      'cambios',
      'muestras',
      'originales',
      'presupuestosInternos'
    ]),
    mecanicaPromocionalVisible() {
      /* Unicamente visible si está activa la primer pestaña (especificaciones) */
      if (this.tabIndex == 0) {
        if (this.tiposDisenios) {
          let mecanicaPromocional = this.tiposDisenios.find(t => (/true/i).test(t.mecanicaPromocional) && (/true/i).test(t.selected));
          
          if (mecanicaPromocional) {
            return true;
          }
        }
      }
      return false;
    },
    isAccionOtros() {
      return (/true/i).test(this.accionOtros);
    },
    presupuestosNumero() {
      if (this.presupuestosInternos) {
        return this.presupuestosInternos.map(({ presupuestoNumero }) => presupuestoNumero).join(' | ');
      }

      return '';
    }
  },  
  created() {
    let route = this.$router.resolve({ name: 'BriefEdit', params: { id: -1 } }).route;
    this.opcionEditarBrief = Boolean(this.$store.getters['user/tieneAcceso'](route));

    let briefId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        briefId = this.$route.params.id;
      }
    }

    this.showSpinner();
    this.$store.dispatch('briefDatos/getBrief', briefId)
      .then(() => {
        this.$refs.marcas.refresh();
        this.$refs.tiposDisenios.refresh();
        this.$refs.adicionales.refresh();
        this.$refs.cambios.refresh();
        this.$refs.muestras.refresh();
        this.$refs.originales.refresh();
        // this.$refs.validaciones.refresh();
      })
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner())
  },
  methods: {
    setTabIndex(e) {
      this.tabIndex = parseInt(e);
    },
    goList() {
      this.$router.push({ name: 'Briefs' });
    },
    editar() {
      if (this.isCerrado) {
        this.showErrorMsj('El brief se encuentra cerrado, no se puede editar la información del mismo.');
        return;
      }

      this.$router.push({ name: 'BriefEdit', 
                          params: { id: this.id }});
    },
    addMuestra() {
      if (this.isCerrado) {
        this.showErrorMsj('El brief se encuentra cerrado, no se puede editar la información del mismo.');
        return;
      }

      this.$refs.addMuestraModal.show();
    },
    savedMuestra(muestra) {
      this.$refs.addMuestraModal.hide();
      if (muestra) {
        muestra.briefId = this.id;

        this.showSpinner();
        this.$store.dispatch('briefDatos/addMuestra', muestra)
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.hideSpinner());
      }
    },
    closeMuestra() {
      this.$refs.addMuestraModal.hide();
    },
    removeMuestra(muestraId) {
      if (this.isCerrado) {
        this.showErrorMsj('El brief se encuentra cerrado, no se puede editar la información del mismo.');
        return;
      }

      this.showModalConfirm('Desea eliminar la muestra seleccionada?', 
        this.removeMuestraSeleccionada.bind(this, muestraId), 'Si', null, 'No');
    },
    removeMuestraSeleccionada(muestraId) {
      let params = {
        briefId: this.id,
        muestraId
      }
      
      this.showSpinner();
      this.$store.dispatch('briefDatos/removeMuestra', params)
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    addOriginal() {
      if (this.isCerrado) {
        this.showErrorMsj('El brief se encuentra cerrado, no se puede editar la información del mismo.');
        return;
      }

      this.$refs.addOriginalModal.show();
    },
    savedOriginal(original) {
      this.$refs.addOriginalModal.hide();
      if (original) {
        original.briefId = this.id;
        original.validado = original.isValidado;

        this.showSpinner();
        this.$store.dispatch('briefDatos/addOriginal', original)
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.hideSpinner());
      }
    },
    closeOriginal() {
      this.$refs.addOriginalModal.hide();
    },
    removeOriginal(originalId) {
      if (this.isCerrado) {
        this.showErrorMsj('El brief se encuentra cerrado, no se puede editar la información del mismo.');
        return;
      }

      this.showModalConfirm('Desea eliminar el original seleccionado?', 
        this.removeOriginalSeleccionado.bind(this, originalId), 'Si', null, 'No');
    },
    removeOriginalSeleccionado(originalId) {
      let params = {
        briefId: this.id,
        originalId
      }
      this.showSpinner();
      this.$store.dispatch('briefDatos/removeOriginal', params)
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    validarInformacionEntrega(muestra) {
      if (this.isCerrado) {
        this.showErrorMsj('El brief se encuentra cerrado, no se puede editar la información del mismo.');
        return;
      }

      this.briefMuestraId = muestra.id;
      this.briefMuestraEspecificaciones = muestra.especificaciones;
      this.$refs.validacionInformacionModal.show();
    },
    registrarValidacionInformacion(params) {
      this.$refs.validacionInformacionModal.hide();

      params.briefId = this.id;
      params.briefMuestraId = this.briefMuestraId;
      params.observaciones = '';

      this.showSpinner();
      this.$store.dispatch('briefsEntregas/addValidacionInformacion', params)
        .then(() => this.showModalMsj('La validación comercial se registró con éxito.', 
          this.actualizarValidacionMuestra.bind(this, params), 
          this.actualizarValidacionMuestra.bind(this, params), 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    actualizarValidacionMuestra(params) {
      this.$store.dispatch('briefDatos/actualizarValidacionMuestra', params)
        .catch(error => this.showErrorMsj(error));
    },
    cancelarValidacionInformacion() {
      this.$refs.validacionInformacionModal.hide();
    },
    addEspecificacionesMuestra(muestraId) {
      if (this.isCerrado) {
        this.showErrorMsj('El brief se encuentra cerrado, no se puede editar la información del mismo.');
        return;
      }

      this.briefMuestraId = muestraId;
      this.$refs.especificacionesMuestraModal.show();
    },
    registrarEspecificacionesMuestra(params) {
      this.$refs.especificacionesMuestraModal.hide();

      params.briefId = this.id;
      params.briefMuestraId = this.briefMuestraId;
      params.observaciones = '';

      this.showSpinner();
      this.$store.dispatch('briefsEntregas/addEspecificacionesMuestra', params)
        .then(() => this.showModalMsj('Las especificaciones de la muestra se registraron con éxito.', 
          this.actualizarEspecificacionesMuestra.bind(this, params), 
          this.actualizarEspecificacionesMuestra.bind(this, params), 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    actualizarEspecificacionesMuestra(params) {
      this.$store.dispatch('briefDatos/actualizarEspecificacionesMuestra', params)
        .catch(error => this.showErrorMsj(error));
    },
    cancelarEspecificacionesMuestra() {
      this.$refs.especificacionesMuestraModal.hide();
    },
    validarTecnicaEntrega(original) {
      if (this.isCerrado) {
        this.showErrorMsj('El brief se encuentra cerrado, no se puede editar la información del mismo.');
        return;
      }

      this.showModalConfirm('¿Validaste que el archivo cumpla con los requerimientos técnicos solicitados por el proveedor? Por ejemplo: demasías, tipografías, calidad de las imágenes, planos, muestras en jpg, etc.', 
        this.registrarValidacionTecnica.bind(this, original.id), 'Si', 
        null, 'No');
    },
    registrarValidacionTecnica(briefOriginalId) {
      let params = {
        briefId: this.id,
        briefOriginalId,
        observaciones: ''
      }
      this.showSpinner();
      this.$store.dispatch('briefsEntregas/addValidacionTecnica', params)
        .then(() => this.showModalMsj('La validación técnica se registró con éxito.', 
          this.actualizarValidacionOriginal.bind(this, briefOriginalId), 
          this.actualizarValidacionOriginal.bind(this, briefOriginalId), 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    actualizarValidacionOriginal(briefOriginalId) {
      this.$store.dispatch('briefDatos/actualizarValidacionOriginal', briefOriginalId)
        .catch(error => this.showErrorMsj(error));
    },
    addSolicitudCambios(original) {
      if (this.isCerrado) {
        this.showErrorMsj('El brief se encuentra cerrado, no se pueden registrar solicitudes de cambios.');
        return;
      }

      this.briefOriginalId = original.id;
      this.$refs.cambiosModal.show();
    },
    solicitudCambiosRegistrada(solicitudCambios) {
      solicitudCambios.briefOriginalId = this.briefOriginalId;
      solicitudCambios.usuario = this.$store.getters['user/nombreCompleto'];
      // console.log(solicitudCambios);
      this.$refs.cambiosModal.hide();
      this.$store.dispatch('briefDatos/addSolicitudCambiosOriginal', solicitudCambios)
        .then(() => this.showModalMsj('La solicitud se registró con éxito.', null, null, 'light'))
        .catch(error => this.showErrorMsj(error));
    },
    cancelarCambios() {
      this.$refs.cambiosModal.hide();
    },
    deleteSolicitudCambios(params) {
      if (this.isCerrado) {
        this.showErrorMsj('El brief se encuentra cerrado, no se pueden eliminar solicitudes de cambios.');
        return;
      }

      this.showModalConfirm('¿Desea eliminar la solicitud de cambios seleccionada?', 
          this.deleteSolicitudCambiosSeleccionda.bind(this, params), 'Si', 
          null, 'No');
    },
    deleteSolicitudCambiosSeleccionda(params) {
      params.briefId = this.id;

      this.showSpinner();
      this.$store.dispatch('briefsEntregas/deleteSolicitudCambios', params)
        .then(() => {
          return this.$store.dispatch('briefDatos/deleteSolicitudCambiosOriginal', params);
        })
        .then(() => {
          // this.showModalMsj('La solicitud se registró con éxito.', null, null, 'light')
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    solucionarSolicitudCambios(params) {
      this.showModalConfirm('¿Desea marcar como solucionada la solicitud de cambios seleccionada?', 
          this.solucionarSolicitudCambiosSeleccionada.bind(this, params), 'Si', 
          null, 'No');
    },
    solucionarSolicitudCambiosSeleccionada(params) {
      params.briefId = this.id;

      this.showSpinner();
      this.$store.dispatch('briefsEntregas/solucionarSolicitudCambios', params)
        .then(() => {
          return this.$store.dispatch('briefDatos/solucionarSolicitudCambiosOriginal', params);
        })
        .then(() => {
          // this.showModalMsj('La solicitud se registró con éxito.', null, null, 'light')
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    }
  },
}
</script>

<style>
  .brief-datos .tabs .tab-pane {
    min-height: 400px;
    padding-top: 30px;
  }

  div.brief-card-header .card-body {
    padding: 0;
  }
  div.brief-card-header .card-body > div {
    padding: 20px;
  }
  .brief-datos hr {
    margin-bottom: 30px;
    margin-top: 30px;
  }
  .brief-datos .custom-check-input {
    margin-left: 30px;
  }

  .brief-datos .brief-header .card-body {
    padding: 0;
  }
  .brief-datos .brief-header .card-body > div {
    padding: 20px;
  }

  .brief-datos label.titulo {
    /* margin-top: 10px; */
    margin-bottom: 20px;
  }

  .brief-datos .subtitulo,
  .brief-datos .subtitulo > label,
  .brief-datos .subtitulo > small {
    display: block;
  }
  .brief-datos .subtitulo {
    margin-bottom: 15px;
  }
  .brief-datos .subtitulo > label {
    margin-bottom: 3px;
  }

  .brief-datos .titulo,
  .brief-datos .subtitulo {
    font-weight: 600;
  }

  .brief-datos .list-group .list-group-item {
    border-top: none;
    border-bottom: none;
    padding-top: 8px;
    padding-bottom: 8px;    
  }
  .brief-datos .list-group .list-group-item p {
    margin-bottom: 0 !important;
  }

  .brief-datos .list-group.accion-objetivos .list-group-item,
  .brief-datos .list-group.formas-entrega .list-group-item {
    padding-left: calc(16.66667% + 12px);
  }

  .brief-datos hr.separador-entregas {
    border-top: 1px solid rgba(0, 0, 0, 0.3);
  }

</style>
